import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-dc-plus-minus',
  templateUrl: './dc-plus-minus.component.html',
  styleUrls: ['./dc-plus-minus.component.scss']
})
export class DcPlusMinusComponent implements OnInit {

  @Input()
  showPlus: boolean;

  @Input()
  showMinus: boolean = true;

  @Output()
  minusClick = new EventEmitter<any>();

  @Output()
  plusClick = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  onButtonClicked(event: any, type: 'minus' | 'plus'): void {
    if (type === 'minus') {
      this.minusClick.emit(event);
    } else {
      this.plusClick.emit(event);
    }
  }

}
